import { SvgIcon, SvgIconProps } from '@mui/material';

export type CloseIconProps = SvgIconProps & {
  fullGlyph?: boolean;
};

export function CloseIcon({ fullGlyph = false, ...props }: CloseIconProps) {
  if (fullGlyph) {
    return (
      <SvgIcon {...props} viewBox="0 0 16 16">
        <path
          d="M2 14L8 8M14 2L8 8M8 8L2 2M8 8L14 14"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  }

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
